import { useState } from 'react'
import { downloadFromUrl, type FileRef } from '@/shared/lib'
import { toast } from '@/shared/ui/toast'

// Клик по файлу — это сеть: presigned-ссылка тянется fetch'ем и отдаётся blob'ом.
// Пока запрос идёт, busy=true — место иконки занимает спиннер, повторный клик
// игнорируется. Один хук на все точки скачивания (документы, версии, счета).
export function useFileDownload() {
  const [busy, setBusy] = useState(false)

  async function download(file: FileRef): Promise<void> {
    if (busy || !file.url) return
    setBusy(true)
    try {
      await downloadFromUrl(file.url, file.file_name)
    } catch {
      toast.error(`Не удалось скачать «${file.file_name}»`)
    } finally {
      setBusy(false)
    }
  }

  return { busy, download }
}
